import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useLayoutEffect, useRef } from 'react';

gsap.registerPlugin(ScrollTrigger);

function SplitText({ text }) {
  return (
    <>
      {text.split('').map((char, index) => (
        <span className="hero-char" key={`${char}-${index}`}>
          {char === ' ' ? '\u00a0' : char}
        </span>
      ))}
    </>
  );
}

export default function Hero({ images }) {
  const root = useRef(null);
  const heroImage = images[0];

  useLayoutEffect(() => {
    if (!root.current || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;

    const context = gsap.context(() => {
      const intro = gsap.timeline({ defaults: { ease: 'power4.out' } });
      intro
        .from('.hero__curtain', { scaleX: 1, transformOrigin: 'left', duration: 1.2 })
        .from('.hero-char', { yPercent: 120, rotateX: -75, opacity: 0, stagger: 0.035, duration: 1.05 }, 0.25)
        .from('.hero__copy > *', { y: 36, opacity: 0, stagger: 0.12, duration: 0.9 }, 0.55)
        .from('.hero__image-layer', { clipPath: 'inset(100% 0 0 0)', y: 80, stagger: 0.13, duration: 1.2 }, 0.2);

      gsap.to('.hero__bg img', {
        scale: 1.18,
        yPercent: 10,
        ease: 'none',
        scrollTrigger: {
          trigger: root.current,
          start: 'top top',
          end: 'bottom top',
          scrub: true
        }
      });

      gsap.to('.hero__title', {
        xPercent: -10,
        ease: 'none',
        scrollTrigger: {
          trigger: root.current,
          start: 'top top',
          end: 'bottom top',
          scrub: true
        }
      });
    }, root);

    return () => context.revert();
  }, []);

  return (
    <section className="hero" ref={root}>
      <div className="hero__bg" aria-hidden="true">
        {heroImage && <img src={heroImage.src} alt="" fetchPriority="high" />}
      </div>
      <div className="hero__curtain" aria-hidden="true" />
      <div className="hero__chrome">
        <p>Dark editorial photography / Stuttgart and beyond</p>
      </div>
      <div className="hero__title" aria-label="Stefan Maldet">
        <SplitText text="Stefan Maldet" />
      </div>
      <div className="hero__copy">
        <p className="mono-label">No polite archive</p>
        <h1>Photography as pressure. Beauty with a cut.</h1>
        <p>
          Ein visueller Strom aus Haltung, Charakter und Spannung. Roh genug, um zu bleiben. Präzise genug, um
          nicht laut werden zu müssen.
        </p>
      </div>
      <div className="hero__stack" aria-hidden="true">
        {images.slice(1, 5).map((image, index) => (
          <img className="hero__image-layer" src={image.src} alt="" key={image.id} style={{ '--i': index }} />
        ))}
      </div>
      <a className="hero__scroll" href="#work">
        Scroll / descend
      </a>
    </section>
  );
}
